module.exports = __webpack_public_path__ + "img/jindu_touxian.7056ad0e.png";